// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import FlexWrapContainer from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import { productPriceAndActionsStyle } from "@pace/App/Components/Product/ProductPriceAndActions";
import IconPaginationArrowRight from "@pace/XDL/Icons/IconPaginationArrowRight";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, createLinkIconStyles, getSystemColor, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            height: unset;
            max-width: unset;
            gap: 12px;
            &, & > div {
                height: 100%;
            }
            ${xScreen("lt", "md")} {
                max-width: unset;
            }
        `,
    },
};
productPriceAndActionsStyle.productActionsStyles = {
    addToCartContainer: {
        css: css`
            justify-content: space-between;
        `,
    },
    addToCartButtonWrapper: {
        css: css`
            flex-grow: 1;
        `,
    },
};

productPriceAndActionsStyle.productListProductImageStyles = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    compareCheckbox: {
        css: css`
            margin: 0;
        `,
    },
};

productPriceAndActionsStyle.priceAvailabilityLink = {
    color: "text.link",
    hoverStyle: {
        color: getSystemColor("common.ui9"),
    },
    icon: {
        iconProps: {
            src: IconPaginationArrowRight,
            size: 5,
            color: "text.link",
        },
        position: "right",
    },
    typographyProps: {
        size: 10,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: 13px;
        `,
    },
    css: css`
        ${IconWrapper} {
            margin-left: 4px;
        }
    `,
};

productPriceAndActionsStyle.imageBadgesStyles = {
    container: {
        css: css`
            flex: auto;
            ${FlexWrapContainer} {
                gap: 4px;
                flex: 1;
                justify-content: end;
            }
        `,
    },
    image: {
        css: css`
            width: 14px;
            height: 14px;
        `,
    },
    imageItem: {
        css: css`
            flex: 1;
            padding: 0;
            width: 24px;
            max-width: 24px;
            height: 24px;
        `,
    },
};

productPriceAndActionsStyle.priceBadgesContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    `,
};

productPriceAndActionsStyle.loginActionButton = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        weight: fontConfig.weight.bold,
    },
    css: css`
        padding-block: 8px;
        border-radius: 4px;
    `,
};

productPriceAndActionsStyle.goToPage = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        underline: true,
    },
    css: css`
        margin-left: 8px;
    `,
};

productPriceAndActionsStyle.productListProductImageStyles = {
    /* as actions this is the compare button */
    compareCheckbox: {
        css: css`
            padding: 0;
            vertical-align: middle;
        `,
    },
    wrapper: {
        css: css`
            margin-right: auto;
            width: fit-content;
        `,
    },
};

productPriceAndActionsStyle.productAddToListStyles = {
    link: createLinkIconStyles(PlusCircle, {
        icon: {
            iconProps: {
                css: css`
                    opacity: 0.5;
                    & > svg {
                        height: 13px;
                    }
                `,
            },
            position: "left",
        },
    }),
};
productPriceAndActionsStyle.productAvailabilityStyles = {
    messageLabel: {
        size: 13,
    },
    availabilityByWarehouseLink: {
        typographyProps: {
            size: 10,
        },
    },
    actionsGridItem: {
        css: css`
            align-items: flex-end;
        `,
    },
};
productPriceAndActionsStyle.addPackTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 4px;
            svg {
                width: 12px;
                height: 12px;
                path {
                    color: ${color("text.link", .44)};
                }
            }
        `,
    },
};
productPriceAndActionsStyle.addPackButton = {
    variant: "secondary",
    css: css`
        font-weight: bold;
        font-size: 12px;
    `,
};